export namespace ICar {
  export interface IEntity {
    balance?: number;
    carId?: number;
    carStatusId?: CarStatusId;
    carNumber?: string;
    additionalCarNumber?: string;
    comment?: string;
    corpName?: string;
    corpId?: number;
    dateBeg?: string;
    dateEnd?: string;
    parks?: number[];
    parkName?: string;
    custId?: number;
    dateIn?: string;
    dateOut?: string;
    dayInMonth?: number;
    timeHour?: number;
    timeMinute?: number;
    timePark?: string;
    guestFlag?: boolean;
    model?: string;
    persName?: string;
    phone?: string;
    tmPersonId?: number;
    email?: string;
    tarifId?: number;
    tarifName?: string;
    dateBegTarif?: Date | string;
    payGuestHours?: number;
    payGuestHoursFlag?: boolean;
    password?: string;
    rptBalance?: number;
    nonStandartFlag?: boolean;
    scOpenCarCard?: boolean;
    carTypeId?: number;
    carTypeName?: string;
    disableCancelMovsFlag?: boolean; // Не переводить в «Условно выехавшие»
    freeSaldoFlag?: boolean; // Бесплатный проезд
    disableLevenshteinFlag?: boolean; // Строгое совпадение номера
  }

  export enum CarStatusId {
    Active = 1,
    Wait = 2,
    Expired = 3,
    Archive = 4,
    Parking = 5,
    WithoutCorp = 6,
  }

  export interface ICarMovement extends IEntity {
    movId: number;
    tSum?: number;
  }

  export interface ICarBalance extends IEntity {
    dayInCurMonth: string;
  }

  export interface ICarEvent extends IEntity {
    dateEvent: string;
    eventName: string;
    number: string;
  }

  export enum CarPopupTab {
    Info = 'info',
    Movements = 'movements',
    Camera = 'camera',
    Balance = 'balance',
    Archive = 'archive',
    AntiTheft = 'antiTheft',
  }

  export const CarPopupTabs = {
    [CarPopupTab.Info]: { id: CarPopupTab.Info, label: 'Карточка' },
    [CarPopupTab.Movements]: { id: CarPopupTab.Movements, label: 'Движение' },
    [CarPopupTab.Camera]: { id: CarPopupTab.Camera, label: 'Камеры' },
    [CarPopupTab.Balance]: { id: CarPopupTab.Balance, label: 'Баланс' },
    [CarPopupTab.Archive]: { id: CarPopupTab.Archive, label: 'Журнал' },
    [CarPopupTab.AntiTheft]: { id: CarPopupTab.AntiTheft, label: 'Антиугон' },
  };
}
